<div class="main">
    <div class="container">
        <div class="tab-property tab-scrollX" role="tabpanel" id="create-new-fund">
            <div class="tab-pane in active">
                <div class="row">
                    <div class="col-12">
                        <div class="createProduct">
                            <br />
                            <!-- Tab content -->

                            <div class="tab-content">
                                <!-- Trading Fund -->
                                <div class="tab-pane show active" id="tab1">
                                    <!-- SIP -->
                                    <form action="" [formGroup]="editForm">
                                        <div class="createProduct__inner">
                                            <div class="row">
                                                <!-- Chọn quỹ  -->
                                                <div class="form-group col-6 col-md-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Chọn quỹ (tên
                                                        viết tắt)
                                                        <span class="required">*</span>
                                                    </label>

                                                    <dropdown formControlName="fundId"  [list]="funds" [field]="'code'"
                                                         [title]="'Chọn quỹ (tên viết tắt)'">
                                                    </dropdown>

                                                    <span class="error-text"
                                                        *ngIf="isValidated && editForm.get('fundId')?.errors?.required">
                                                        {{'product.create.required_field' | translate }}
                                                    </span>
                                                </div>

                                                <!-- Mã giao dịch thường -->
                                                <div class="form-group col-6 col-md-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Mã giao dịch
                                                        <span class="required">*</span>
                                                    </label>
                                                    <input type="text" class="form-control"
                                                        formControlName="tradingVSD">
                                                    <span class="error-text"
                                                        *ngIf="isValidated && editForm.get('tradingVSD')?.errors?.required">
                                                        {{'product.create.required_field' | translate }}
                                                    </span>
                                                </div>

                                                <div class="form-group col-6 col-md-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Mã phí VSD
                                                        <span class="required">*</span>
                                                    </label>
                                                    <input type="text" class="form-control" formControlName="codeVSD">
                                                    <span class="error-text"
                                                        *ngIf="isValidated && editForm.get('codeVSD')?.errors?.required">
                                                        {{'product.create.required_field' | translate }}
                                                    </span>
                                                </div>

                                                <!-- Số tiền mua tối thiểu -->
                                                <div class="form-group col-12 col-md-6 col-sm-6">
                                                    <label class="control-label input-title no-padding"> Số tiền mua tối
                                                        thiểu
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input-number  [isDecimal]="true" formControlName="minBuy">
                                                            </input-number>
                                                            <span
                                                                class="input-group-addon">{{'product.currency_no_border'
                                                                | translate }}</span>
                                                        </div>
                                                        <span class="error-text"
                                                            *ngIf="isValidated && editForm.get('minBuy')?.errors?.required">
                                                            {{'product.create.required_field' | translate }}
                                                        </span>
                                                    </div>

                                                </div>

                                                <!-- Số lượng bán tối thiểu -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Số lượng bán tối
                                                        thiểu
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input-number  [isDecimal]="true" formControlName="minSell">
                                                            </input-number>
                                                        </div>
                                                        <span class="error-text"
                                                            *ngIf="isValidated && editForm.get('minSell')?.errors?.required">
                                                            {{'product.create.required_field' | translate }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <!-- Số lượng nắm giữ tối thiểu -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Số lượng nắm giữ
                                                        tối
                                                        thiểu
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input-number  [isDecimal]="true" formControlName="minHold">
                                                            </input-number>
                                                        </div>
                                                        <span class="error-text"
                                                            *ngIf="isValidated && editForm.get('minHold')?.errors?.required">
                                                            {{'product.create.required_field' | translate }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <!-- Thời gian đầu tư liên tục tối thiểu  -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Thời gian đầu tư
                                                        liên tục tối thiểu(tháng)
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input-number  formControlName="monthInvest">
                                                             </input-number>
                                                        </div>
                                                        <span class="error-text"
                                                            *ngIf="isValidated && editForm.get('monthInvest')?.errors?.required">
                                                            {{'product.create.required_field' | translate }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <!-- Thời gian đầu tư tối đa  -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Thời gian đầu tư
                                                        tối đa
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input-number  formControlName="maxMonthInvest">
                                                            </input-number>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Thời gian đầu tư tối đa  -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Chu kì thanh
                                                        toán
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input type="text" class="form-control buyMinValue"
                                                                value="Hàng tháng" disabled>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Ngày thanh toán chậm nhất  -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Ngày thanh toán
                                                        chậm nhất
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input-group ">
                                                        <div class="row d-flex flex-row">
                                                            <div class="col-6 d-flex flex-row radio-group">
                                                                <div class="form-check form-check-inline">
                                                                    <input class="form-check-input" type="radio"
                                                                        name="isFixed" formControlName="isFixed"
                                                                        value="false">
                                                                    <label class="form-check-label"
                                                                        for="inlineRadio1">Linh
                                                                        hoạt</label>

                                                                </div>
                                                            </div>
                                                            <div class="col-6 d-flex flex-row radio-group">
                                                                <div class="form-check form-check-inline">
                                                                    <input class="form-check-input" type="radio"
                                                                        name="isFixed" formControlName="isFixed"
                                                                        value="true">
                                                                    <label class="form-check-label"
                                                                        for="inlineRadio2">Cố
                                                                        định</label>

                                                                </div>
                                                                <select class="form-control"
                                                                    formControlName="lastTransferDay">
                                                                    <option style="font-style:italic">--Chọn ngày--
                                                                    </option>
                                                                    <option *ngFor="let day of days" [ngValue]="day">
                                                                        {{day}} </option>
                                                                </select>

                                                            </div>
                                                        </div>

                                                    </div>
                                                    <span class="error-text"
                                                        *ngIf="isValidated && editForm.get('isFixed').value === 'true' && !editForm.get('lastTransferDay')?.value">
                                                        {{'product.create.required_field' | translate }}
                                                    </span>
                                                </div>
                                                 <!-- Cố định số tiền  -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">
                                                        Cố định số tiền
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="form-check form-check-inline d-flex">
                                                            <div class="custom-control custom-switch">
                                                                <input type="checkbox" class="custom-control-input"
                                                                    id="customSwitch2" formControlName="isFixedRegisterAmount"
                                                                    (click)="patchForm('isFixedRegisterAmount', !editForm.value.isFixedRegisterAmount)"
                                                                    [checked]="editForm.get('isFixedRegisterAmount').value">
                                                                <label class="custom-control-label"
                                                                    for="customSwitch2">Cố định</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                 <div class="form-group col-6 col-sm-6">

                                                 </div>
                                                <!-- Số kỳ liên tục không đầu tư  -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">
                                                        Số kỳ liên tục không đầu tư tối đa cho phép(lớn hơn sẽ deactive)
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input-number  formControlName="noInvestPeriod">
                                                            </input-number>
                                                        </div>
                                                        <span class="error-text"
                                                            *ngIf="isValidated && editForm.get('noInvestPeriod')?.errors?.required">
                                                            {{'product.create.required_field' | translate }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <!-- Số kỳ liên tục không đầu tư  -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">
                                                        Số kỳ KHÔNG đầu tư tối đa cho phép (lớn hơn sẽ deactive)
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input-number formControlName="maxNoncontinuousNoninvestmentCycle">
                                                            </input-number>
                                                        </div>
                                                        <!-- <span class="error-text"
                                                            *ngIf="isValidated && editForm.get('maxNoncontinuousNoninvestmentCycle')?.errors?.required">
                                                            {{'product.create.required_field' | translate }}
                                                        </span> -->
                                                    </div>
                                                </div>
                                                <!-- Tên SIP  -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Tên SIP
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input type="text" class="form-control buyMinValue"
                                                                formControlName="name">
                                                        </div>
                                                        <span class="error-text"
                                                            *ngIf="isValidated && editForm.get('name')?.errors?.required">
                                                            {{'product.create.required_field' | translate }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <!-- Mã chu kỳ  -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Mã chu kỳ
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input type="text" class="form-control buyMinValue"
                                                                formControlName="sipCode">
                                                        </div>
                                                        <span class="error-text"
                                                            *ngIf="isValidated && editForm.get('sipCode')?.errors?.required">
                                                            {{'product.create.required_field' | translate }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <!-- Cho phép chuyển đổi  -->
                                                <div class="form-group col-6 col-sm-6">
                                                    <label class="control-label input-title no-padding">Cho phép chuyển
                                                        đổi
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="form-check form-check-inline d-flex">
                                                            <div class="custom-control custom-switch m-3">
                                                                <input type="checkbox" class="custom-control-input"
                                                                    id="customSwitch3" formControlName="isTransfer"
                                                                    (click)="patchForm('isTransfer', !editForm.value.isTransfer)"
                                                                    [checked]="editForm.get('isTransfer').value">
                                                                <label class="custom-control-label"
                                                                    for="customSwitch3">Chuyển đổi</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-12 col-sm-12">
                                                    <label class="control-label input-title no-padding">Ghi chú
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input type="text" class="form-control buyMinValue"
                                                                formControlName="additionalNote">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-12 col-sm-12">
                                                    <label class="control-label input-title no-padding">Ghi chú (Tiếng Anh)
                                                    </label>
                                                    <div class="input-group d-flex flex-column">
                                                        <div class="input-group d-flex flex-row">
                                                            <input type="text" class="form-control buyMinValue"
                                                                formControlName="additionalNoteEn">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    <hr>
                                </div>
                            </div>
                        </div>
                        <div class="createProduct">
                            <!-- Phí phát hành -->
                            <div class="createProduct__inner">
                                <div class="row create-fund-item createProduct__inner-fee">
                                    <div class="col-12 caption">
                                        <span class="caption-subject">
                                            <strong>{{'product.lease_tax' | translate }} <span class="required">*</span></strong>
                                        </span>
                                    </div>
                                    <app-edit-fee [isValidated]="isValidated" [feeList]="sip.feeBuys" [unitValue]="'MONEY'" [typeCode]="'BUY'"
                                        [relationalOperators]="resource.relationalOperators" [boardcast]="RELEASE_FEE">
                                    </app-edit-fee>
                                </div>
                            </div>
                        </div>
                        <div class="createProduct">
                            <!-- Phí mua lại SIP -->
                            <div class="createProduct__inner">
                                <div class="row create-fund-item createProduct__inner-fee">
                                    <div class="col-12 caption">
                                        <span class="caption-subject">
                                            <strong>Phí mua lại SIP <span class="required">*</span></strong>
                                        </span>
                                        <div class="form-check">
                                            <input type="checkbox" class="form-check-input mr-2" id="exampleCheck1"
                                                [(ngModel)]="isFeeFromFirstTransaction">
                                            <label class="form-check-label" for="exampleCheck1">Tính phí theo kỳ giao
                                                dịch đầu tiên</label>
                                        </div>
                                    </div>

                                    <app-edit-fee [isValidated]="isValidated" [feeList]="sip.feeSells" [isUnitConfig]="true"  [isNoUnitConfigByMoney]="true" [unitValue]="'MONTH'"
                                        [relationalOperators]="resource.relationalOperators" [boardcast]="SELL_FEE" [typeCode]="'SELL'">
                                    </app-edit-fee>
                                </div>
                            </div>
                        </div>
                        <div class="createProduct">
                            <!-- Phí rời SIP trước hạn -->
                            <div class="createProduct__inner">
                                <div class="row create-fund-item createProduct__inner-fee">
                                    <div class="col-12 caption">
                                        <span class="caption-subject">
                                            <strong>Phí rời SIP trước hạn   <span class="required">*</span></strong>
                                        </span>
                                        <div class="form-check">
                                            <input type="checkbox" class="form-check-input  mr-2" id="exampleCheck2"
                                                [(ngModel)]="isFeeFromFirstTransactionBreakSip">
                                            <label class="form-check-label" for="exampleCheck1">Tính phí theo kỳ giao
                                                dịch đầu tiên</label>
                                        </div>
                                    </div>
                                    <app-edit-fee [isValidated]="isValidated" [feeList]="sip.feePenalty" [isUnitConfig]="true"  [unitValue]="'MONTH'"  [isNoUnitConfigByMoney]="true"
                                        [relationalOperators]="resource.relationalOperators" [boardcast]="SELL_PENALTY" [typeCode]="'SELL_PENALTY'">
                                    </app-edit-fee>
                                </div>
                            </div>
                        </div>
                        <div class="createProduct">
                            <div class="createProduct__inner">
                                <div class="row create-fund-item createProduct__inner-fee">
                                    <form action="" [formGroup]="editForm">
                                        <div class="row">

                                            <div class="col-12 caption">
                                                <div class="d-flex justify-content-between">
                                                    <span class="caption-subject">
                                                        <strong>Tài khoản ngân hàng giám sát</strong>
                                                    </span>
                                                    <button class="btn btn-ok btn-clear m-3" (click)="clearBank()"
                                                        style="margin-right: 5px">
                                                        Xoá
                                                    </button>
                                                </div>

                                            </div>
                                            <!-- Tên tài khoản  -->
                                            <div class="form-group col-6 col-md-6 col-sm-6">
                                                <label class="control-label input-title no-padding">Tên tài khoản
                                                </label>

                                                <input type="text" class="form-control" formControlName="bankName">
                                            </div>

                                            <!-- Số tài khoản  -->
                                            <div class="form-group col-6 col-md-6 col-sm-6">
                                                <label class="control-label input-title no-padding">Số tài khoản
                                                </label>

                                                <input type="text" class="form-control" formControlName="bankNumber">
                                            </div>

                                            <div class="form-group col-6 col-md-6 col-sm-6">
                                                <label class="control-label input-title no-padding">Ngân hàng
                                                </label>

                                                <dropdown formControlName="bankId" [list]="banks" [field]="'shortname'"
                                                    [title]="'Chọn Ngân hàng'">
                                                </dropdown>
                                            </div>

                                            <div class="form-group col-6 col-md-6 col-sm-6">
                                                <label class="control-label input-title no-padding">Mã ngân hàng (chuyển tiền reward)
                                                </label>

                                                <input type="text" class="form-control" formControlName="bankCode">
                                            </div>

                                            <!-- Chi nhánh  -->
                                            <div class="form-group col-6 col-md-6 col-sm-6">
                                                <label class="control-label input-title no-padding">Chi nhánh
                                                </label>
                                                <input type="text" class="form-control" formControlName="branch">
                                            </div>

                                            <!-- DLPP -->
                                             <div class="form-group col-6 col-md-6 col-sm-6">
                                                <label class="control-label input-title no-padding">ĐLPP
                                                </label>
                                                <input type="text" class="form-control" formControlName="agentName">
                                            </div>

                                             <!-- Ghi chú chuyển khoản -->
                                            <div class="col-12">
                                                <div class="form-group col-12">
                                                    <label class="control-label col-md-12 input-title no-padding">
                                                        Ghi chú chuyển khoản
                                                    </label>
                                                    <textarea class="col-md-12" rows="3" formControlName="bankAccountComment"
                                                        minlength="1" maxlength="160"
                                                        placeholder="Thanh toán tiền mua từ tài khoản ngân hàng đứng tên Nhà đầu tư"></textarea>
                                                    <span id="charNum">{{editForm.value.bankAccountComment?.length || 0}}/160</span>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="createProduct">
                            <div class="row">
                                <div class="col-12 col-md-12"
                                    style="display: flex; justify-content: space-between; align-items: center;">
                                    <div class="custom-control custom-switch m-3">
                                        <input type="checkbox" class="custom-control-input" id="customSwitch1"
                                            [(ngModel)]="isEnable" (click)="changeEnable()" [checked]="isEnable">
                                        <label class="custom-control-label" for="customSwitch1">Kích hoạt</label>
                                    </div>
                                    <button class="btn btn-ok btn--green m-3" (click)="test()"
                                        style="margin-right: 5px"><i nz-icon nzType="sync" nzTheme="outline"></i><span
                                            style="margin-left: 5px">
                                            {{!id ? 'Tạo mới' : 'Sửa đổi'}}
                                        </span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>